import { render, staticRenderFns } from "./PrePaid.vue?vue&type=template&id=5b8753c9&scoped=true"
import script from "./PrePaid.vue?vue&type=script&lang=js"
export * from "./PrePaid.vue?vue&type=script&lang=js"
import style0 from "./PrePaid.vue?vue&type=style&index=0&id=5b8753c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8753c9",
  null
  
)

export default component.exports